module.exports = __webpack_public_path__ + "img/connected-data.defe63c0.svg";